import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import { BasicDoc, Hit } from "react-instantsearch-core";

import HitCard from "../hit/hitcard-horizontal";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "inline-block",
    flex: 1,
    width: "100%",
    maxWidth: 360,
  },
  gridItem: {
    minHeight: 356,
    height: "auto",
  },
}));

const HitsRows: React.FunctionComponent<any> = (props) => {
  const { hits }: { hits: Hit<BasicDoc>[] } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {hits.map((hit: Hit<BasicDoc>, i: number): JSX.Element => {

        return (
          <Grid className={'new-icon-padding new-icon-rows'} item xs={12} key={`hr-${i}`}>
            <HitCard className={classes.card} key={`hit-${hit.id}`} hit={hit} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default HitsRows;
